import React, { useEffect, useState } from "react";
import SummaryApi from "../common";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { IoIosCloseCircle } from "react-icons/io";

const EnrollStudent = () => {
  const [formData, setFormData] = useState({
    student_name: "",
    gender: "",
    father_name: "",
    mobile_number1: "",
    mobile_number2: "",
    email: "",
    aadhar_number: "",
    state: "",
    district: "",
    city: "",
    address: "",
    pincode: "",
    course: "", // This can be for their previous course like 'MPC', 'BiPC' etc.
    clg_name: "",
    inter_percentage: "",
    program_type: "",
    department: "", // Will be set programmatically for UG
    ug_pg_course: "",
    call_status: "",
    call_duration: "00:00:00.000000",
    remarks: "",
    is_interested: "",
    call_back_reason: "",
    other_reasons: "", // Added for the 'Others' option
    is_joined: "",
    joined_clg: "",
  });

  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const navigate = useNavigate();
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [dropdownValue, setDropdownValue] = useState("");
  const [timer, setTimer] = useState("00:00:00");
  const [intervalId, setIntervalId] = useState(null);
  const [inTime, setInTime] = useState("");

  const coursesData = {
    // Diploma: {
    //   "Paramedical Science": [
    //     "MLT (Medical Lab Technology)",
    //     "MIT (Imaging Technology)",
    //     "OPT (Opthalmic Technique)",
    //     "OT & AT (Operation Theatre & Anesthesia Technology)",
    //     "HI (Health Inspector)",
    //     "DT (Dialysis Technology)",
    //   ],
    // },
    UG: [
       "B.Pharma",
      "B.pharma in MLT",
      "B.Sc(Hons.) in BioScience",
      "B.Sc(Hons.) in Chemistry",,
    ],
    // PG: {
    //   "Business & Computer Applications": [
    //     "MBA (Master of Business Administration)",
    //     "MCA (Master of Computer Applications)",
    //   ],
    // },
  };

  const departments =
    formData.program_type && coursesData[formData.program_type] && !Array.isArray(coursesData[formData.program_type])
      ? Object.keys(coursesData[formData.program_type])
      : [];

  const courses =
    formData.program_type === "UG"
      ? coursesData.UG
      : formData.program_type && formData.department && coursesData[formData.program_type]
      ? coursesData[formData.program_type][formData.department]
      : [];


  useEffect(() => {
    if (departments.length === 1 && formData.department !== departments[0]) {
      setFormData((prev) => ({ ...prev, department: departments[0] }));
    }
  }, [departments, formData.department]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === "call_status") {
      if (value === "Not Answered") {
        setFormData((prev) => ({
          ...prev,
          [name]: value,
          is_interested: "",
          call_back_reason: "",
          other_reasons: "",
          is_joined: "",
          joined_clg: "",
          program_type: "",
          department: "",
          ug_pg_course: "",
        }));
        setSelectedCourses([]);
      } else if (value === "Contacted") {
        setFormData((prev) => ({
          ...prev,
          [name]: value,
          is_interested: "",
          other_reasons: "",
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          [name]: value,
          is_interested: "",
          call_back_reason: "",
          other_reasons: "",
          is_joined: "",
          joined_clg: "",
          program_type: "",
          department: "",
          ug_pg_course: "",
        }));
        setSelectedCourses([]);
      }
    } else if (name === "program_type") {
        setFormData(prev => ({
            ...prev,
            program_type: value,
            department: value === 'UG' ? "School of Engineering and Technology" : "",
            ug_pg_course: ""
        }));
        setSelectedCourses([]);
    } else if (name === "is_interested") {
        setFormData(prev => ({
            ...prev,
            is_interested: value,
            ...(value !== 'Call Back' && { call_back_reason: '' }),
            ...(value !== 'Others' && { other_reasons: '' }),
        }));
    } else if (name === "is_joined") {
        setFormData(prev => ({
            ...prev,
            is_joined: value,
            ...(value !== 'Already Joined' && { joined_clg: '' }),
        }));
    } else {
        setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };


  const getFormattedISTTime = () => {
    const now = new Date();
    // Note: Standard practice is to handle timezone conversions on the server.
    // This client-side IST conversion might not be accurate for all users.
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istTime = new Date(now.getTime() + istOffset);
    return istTime.toISOString().slice(0, 19).replace("T", " ");
  };

  const handleSelectChange = (e) => {
    const selectedCourse = e.target.value;
    if (selectedCourse && !selectedCourses.includes(selectedCourse)) {
      setSelectedCourses((prev) => [...prev, selectedCourse]);
    }
    setDropdownValue("");
  };

  useEffect(() => {
    setInTime(getFormattedISTTime());
    const id = setInterval(() => {
      setTimer((prevTimer) => {
        const parts = prevTimer.split(":").map(Number);
        let totalSeconds = parts[0] * 3600 + parts[1] * 60 + parts[2] + 1;
        const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
        const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
          2,
          "0"
        );
        const secs = String(totalSeconds % 60).padStart(2, "0");
        return `${hours}:${minutes}:${secs}`;
      });
    }, 1000);
    setIntervalId(id);
    return () => clearInterval(id);
  }, []);

  // *** MODIFIED VALIDATION LOGIC ***
  const validateForm = () => {
    const { call_status, is_interested, call_back_reason, other_reasons, is_joined, joined_clg } = formData;

    if (!call_status) {
        toast.warning("Please select a Call Status.");
        return false;
    }

    if (call_status === 'Contacted') {
        // Validation for interest level is now optional unless a specific path is taken
        if (is_interested === 'Call Back' && !call_back_reason) {
            toast.warning('Please select a Call Back reason.');
            return false;
        }
        if (is_interested === 'Others' && !other_reasons) {
            toast.warning('Please specify the "Other" reason.');
            return false;
        }
        if (is_joined === 'Already Joined' && !joined_clg) {
          toast.warning('Please enter the name of the joined college.');
          return false;
        }
    }
    // "Not Answered" and other cases have no specific validation and will pass
    return true;
  };

  const handleRemoveTag = (course) => {
    setSelectedCourses((prev) => prev.filter((c) => c !== course));
  };

  const headers = {
    Authorization: "Bearer indrashil_university_916",
    "Content-Type": "application/json",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    setLoadingSubmit(true);
    
    try {
      const encodedEmployeeId = sessionStorage.getItem("H7Z4L9VD2XK5JW8QRYT6");
      if (!encodedEmployeeId)
        throw new Error("Employee ID not found in session storage");

      const decodedEmployeeId = atob(encodedEmployeeId);
      const payload = {
        employee_id: decodedEmployeeId,
        student_name: formData.student_name,
        gender: formData.gender,
        last_name: '',
        father_name: formData.father_name,
        mobile_number1: formData.mobile_number1,
        mobile_number2: formData.mobile_number2 || "",
        email: formData.email || "",
        aadhar_number: formData.aadhar_number || "",
        state: formData.state,
        district: formData.district,
        city: formData.city,
        address: formData.address,
        pincode: formData.pincode || "",
        course: formData.course,
        clg_name: formData.clg_name,
        inter_percentage: formData.inter_percentage,
        program_type: formData.program_type,
        department: formData.department,
        ug_pg_course: selectedCourses.join(", "),
        call_status: formData.call_status || "",
        call_duration: timer,
        remarks: formData.remarks || "",
        is_interested:
          formData.is_interested === "Others"
            ? formData.other_reasons
            : formData.is_interested,
        call_back_reason: formData.call_back_reason || "",
        is_joined: formData.is_joined,
        joined_clg: formData.is_joined === 'Already Joined' ? formData.joined_clg : "",
      };

      const response = await fetch(SummaryApi.uploadStudent.url, {
        method: SummaryApi.uploadStudent.method,
        headers,
        body: JSON.stringify(payload),
      });

      if (!response.ok)
        throw new Error(`Network response was not ok: ${response.statusText}`);

      const result = await response.json();

      if (result.status) {
        toast.success("Student added successfully!");
        const studentId = result.student_id;
        const currentOutTime = getFormattedISTTime();

        await fetch(SummaryApi.calllogsstudentcreate.url, {
          method: SummaryApi.calllogsstudentcreate.method,
          headers,
          body: JSON.stringify({
            employee_id: decodedEmployeeId,
            student_id: studentId,
            in_time: inTime,
            out_time: currentOutTime,
            remarks: formData.remarks || "",
          }),
        });

        navigate("/enrolled-students");
        resetForm();
      } else {
        toast.error(result.message || "Failed to add student.");
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    } finally {
      setLoadingSubmit(false);
    }
  };

  const resetForm = () => {
    setFormData({
      student_name: "",
      gender: "",
      father_name: "",
      mobile_number1: "",
      mobile_number2: "",
      email: "",
      aadhar_number: "",
      state: "",
      district: "",
      city: "",
      address: "",
      pincode: "",
      course: "",
      clg_name: "",
      inter_percentage: "",
      program_type: "",
      department: "",
      ug_pg_course: "",
      call_status: "",
      call_duration: "00:00:00.000000",
      remarks: "",
      is_interested: "",
      call_back_reason: "",
      other_reasons: "",
      is_joined: "",
      joined_clg: "",
    });
    setSelectedCourses([]);
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Enroll Student</h1>
        <div className="text-2xl font-medium bg-gradient-to-r from-blue-500 to-purple-500 text-white px-3 py-1 rounded-lg shadow-md">
          {timer}
        </div>
        <Link to="/enrolled-students">
          <button className="bg-blue-600 text-white px-4 py-2 rounded-md transition-transform transform hover:scale-105">
            Enrolled Students
          </button>
        </Link>
      </div>
      <form
        onSubmit={handleSubmit}
        className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-4 sm:p-8 border rounded-lg shadow-sm"
      >
        {/* --- Personal Details --- */}
        <div className="flex flex-col">
          <label
            htmlFor="student_name"
            className="mb-1 font-medium flex items-center"
          >
            Student Name<span className="ml-1 text-red-600">*</span>
          </label>
          <input
            type="text"
            id="student_name"
            name="student_name"
            value={formData.student_name}
            onChange={handleChange}
            className="p-2 bg-slate-100 border rounded"
            required
          />
        </div>
        <div className="flex flex-col">
          <label
            htmlFor="gender"
            className="mb-1 font-medium flex items-center"
          >
            Gender
          </label>
          <select
            id="gender"
            name="gender"
            value={formData.gender}
            onChange={handleChange}
            className="p-2 bg-slate-100 border rounded"
          >
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div className="flex flex-col">
          <label
            htmlFor="father_name"
            className="mb-1 font-medium flex items-center"
          >
            Father/Guardian Name
          </label>
          <input
            type="text"
            id="father_name"
            name="father_name"
            value={formData.father_name}
            onChange={handleChange}
            className="p-2 bg-slate-100 border rounded"
          />
        </div>
        <div className="flex flex-col">
          <label
            htmlFor="mobile_number1"
            className="mb-1 font-medium flex items-center"
          >
            Mobile Number 1<span className="ml-1 text-red-600">*</span>
          </label>
          <input
            type="tel"
            id="mobile_number1"
            name="mobile_number1"
            value={formData.mobile_number1}
            onChange={(e) => {
              const v = e.target.value.replace(/\D/g, "");
              if (v.length <= 10)
                setFormData((p) => ({ ...p, mobile_number1: v }));
            }}
            className="p-2 bg-slate-100 border rounded"
            required
            pattern="\d{10}"
            title="Mobile number must be 10 digits."
          />
        </div>
        <div className="flex flex-col">
          <label
            htmlFor="mobile_number2"
            className="mb-1 font-medium flex items-center"
          >
            Mobile Number 2
          </label>
          <input
            type="tel"
            id="mobile_number2"
            name="mobile_number2"
            value={formData.mobile_number2}
            onChange={(e) => {
              const v = e.target.value.replace(/\D/g, "");
              if (v.length <= 10)
                setFormData((p) => ({ ...p, mobile_number2: v }));
            }}
            className="p-2 bg-slate-100 border rounded"
            pattern="\d{10}"
            title="Mobile number must be 10 digits."
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="email" className="mb-1 font-medium flex items-center">
            Email
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="p-2 bg-slate-100 border rounded"
          />
        </div>
        <div className="flex flex-col">
          <label
            htmlFor="aadhar_number"
            className="mb-1 font-medium flex items-center"
          >
            Aadhar Number
          </label>
          <input
            type="text"
            id="aadhar_number"
            name="aadhar_number"
            value={formData.aadhar_number}
            onChange={(e) => {
              const v = e.target.value
                .replace(/\D/g, "")
                .slice(0, 12)
                .replace(/(\d{4})(?=\d)/g, "$1-");
              setFormData((p) => ({ ...p, aadhar_number: v }));
            }}
            className="p-2 bg-slate-100 border rounded"
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="state" className="mb-1 font-medium flex items-center">
            State
          </label>
          <input
            type="text"
            id="state"
            name="state"
            value={formData.state}
            onChange={handleChange}
            className="p-2 bg-slate-100 border rounded"
          />
        </div>
        <div className="flex flex-col">
          <label
            htmlFor="district"
            className="mb-1 font-medium flex items-center"
          >
            District
          </label>
          <input
            type="text"
            id="district"
            name="district"
            value={formData.district}
            onChange={handleChange}
            className="p-2 bg-slate-100 border rounded"
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="city" className="mb-1 font-medium flex items-center">
            City
          </label>
          <input
            type="text"
            id="city"
            name="city"
            value={formData.city}
            onChange={handleChange}
            className="p-2 bg-slate-100 border rounded"
          />
        </div>
        <div className="flex flex-col">
          <label
            htmlFor="address"
            className="mb-1 font-medium flex items-center"
          >
            Address
          </label>
          <input
            type="text"
            id="address"
            name="address"
            value={formData.address}
            onChange={handleChange}
            className="p-2 bg-slate-100 border rounded"
          />
        </div>
        <div className="flex flex-col">
          <label
            htmlFor="pincode"
            className="mb-1 font-medium flex items-center"
          >
            Pincode
          </label>
          <input
            type="text"
            id="pincode"
            name="pincode"
            value={formData.pincode}
            onChange={(e) => {
              const v = e.target.value.replace(/\D/g, "");
              if (v.length <= 6) setFormData((p) => ({ ...p, pincode: v }));
            }}
            className="p-2 bg-slate-100 border rounded"
            pattern="\d{6}"
            title="Pincode must be 6 digits."
          />
        </div>

        {/* --- Academic Details --- */}
        <div className="flex flex-col">
          <label
            htmlFor="clg_name"
            className="mb-1 font-medium flex items-center"
          >
            College Name
          </label>
          <input
            type="text"
            id="clg_name"
            name="clg_name"
            value={formData.clg_name}
            onChange={handleChange}
            className="p-2 bg-slate-100 border rounded"
          />
        </div>
        <div className="flex flex-col">
          <label
            htmlFor="inter_percentage"
            className="mb-1 font-medium flex items-center"
          >
            Intermediate Percentage/CGPA
          </label>
          <input
            type="text"
            id="inter_percentage"
            name="inter_percentage"
            value={formData.inter_percentage}
            onChange={handleChange}
            className="p-2 bg-slate-100 border rounded"
          />
        </div>
        <div className="flex flex-col">
          <label
            htmlFor="course"
            className="mb-1 font-medium flex items-center"
          >
            Previous Course
          </label>
          <input
            type="text"
            id="course"
            name="course"
            value={formData.course}
            onChange={handleChange}
            className="p-2 bg-slate-100 border rounded"
          />
        </div>

        {/* --- Call Interaction & Enrollment Details --- */}
        <div className="flex flex-col col-span-1 sm:col-span-2">
          <label
            htmlFor="call_status"
            className="mb-1 font-medium flex items-center"
          >
            Call Status<span className="ml-1 text-red-600">*</span>
          </label>
          <select
            id="call_status"
            name="call_status"
            value={formData.call_status}
            onChange={handleChange}
            className="p-2 bg-slate-100 border rounded"
            required
          >
            <option value="">Select Status</option>
            <option value="Contacted">Contacted</option>
            <option value="Not Answered">Not Answered</option>
          </select>
        </div>

        {/* *** MODIFIED Join Status Field *** */}
        {/* <div className="flex flex-col col-span-1 sm:col-span-2">
            <label htmlFor="is_joined" className="mb-1 font-medium flex items-center">
                Join Status
            </label>
            <select
                id="is_joined"
                name="is_joined"
                value={formData.is_joined}
                onChange={handleChange}
                className="p-2 bg-slate-100 border rounded"
                disabled={formData.call_status !== 'Contacted'}
            >
                <option value="">Select Status</option>
                <option value="Already Joined">Already Joined</option>
                <option value="Not Joined">Not Joined</option>
            </select>
        </div>


        {formData.is_joined === "Already Joined" && (
          <div className="flex flex-col">
            <label
              htmlFor="joined_clg"
              className="mb-1 font-medium flex items-center"
            >
              Joined College Name<span className="ml-1 text-red-600">*</span>
            </label>
            <input
              type="text"
              id="joined_clg"
              name="joined_clg"
              value={formData.joined_clg}
              onChange={handleChange}
              className="p-2 bg-slate-100 border rounded"
              required
            />
          </div>
        )} */}
        
        {/* *** MODIFIED Program Type Field *** */}
        <div className="flex flex-col">
          <label
            htmlFor="program_type"
            className="mb-1 font-medium flex items-center"
          >
            Program Type
          </label>
          <select
            id="program_type"
            name="program_type"
            value={formData.program_type}
            onChange={handleChange}
            className="p-2 bg-slate-100 border rounded"
            disabled={formData.call_status !== 'Contacted'}
          >
            <option value="">Select Program</option>
            <option value="UG">UG</option>
           
          </select>
        </div>

        {formData.program_type && formData.program_type !== 'UG' && (
          <div className="flex flex-col">
            <label
              htmlFor="department"
              className="mb-1 font-medium flex items-center"
            >
              Department<span className="ml-1 text-red-600">*</span>
            </label>
            <select
              id="department"
              name="department"
              value={formData.department}
              onChange={handleChange}
              className="p-2 bg-slate-100 border rounded"
              disabled={formData.call_status !== 'Contacted'}
              required={formData.call_status === 'Contacted' && formData.program_type !== 'UG'}
            >
              <option value="">Select Department</option>
              {departments.map((dept) => (
                <option key={dept} value={dept}>
                  {dept}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* *** MODIFIED Interested Course(s) Field *** */}
        <div className="flex flex-col">
          <label
            htmlFor="ug_pg_course"
            className="mb-1 font-medium flex items-center"
          >
            Interested Course(s)
          </label>
          <select
            id="ug_pg_course"
            name="ug_pg_course"
            value={dropdownValue}
            onChange={handleSelectChange}
            className="p-2 bg-slate-100 border rounded mb-2"
            disabled={courses.length === 0 || formData.call_status !== 'Contacted'}
          >
            <option value="">Select Course(s)</option>
            {courses.map((course) => (
              <option key={course} value={course}>
                {course}
              </option>
            ))}
          </select>
          <div className="flex flex-wrap gap-2">
            {selectedCourses.map((course) => (
              <div
                key={course}
                className="flex items-center bg-blue-100 rounded-full px-3 py-1 text-sm"
              >
                <span>{course}</span>
                <button
                  type="button"
                  className="ml-2"
                  onClick={() => handleRemoveTag(course)}
                >
                  <IoIosCloseCircle className="text-blue-800 w-5 h-5" />
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col col-span-1 sm:col-span-2">
          <label className="mb-2 font-medium">Interest Level</label>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            {[
              "Not Interested",
              "Interested",
              "Most Interested",
              "Call Back",
              "Others",
            ].map((interest) => (
              <label key={interest} className="flex items-center">
                <input
                  type="radio"
                  name="is_interested"
                  value={interest}
                  checked={formData.is_interested === interest}
                  onChange={handleChange}
                  className="mr-2"
                  disabled={formData.call_status !== 'Contacted'}
                />
                {interest}
              </label>
            ))}
          </div>

          {formData.is_interested === "Call Back" && (
            <div className="mt-4 flex items-center">
              <label htmlFor="call_back_reason" className="font-medium mr-4">
                Call Back Reason<span className="ml-1 text-red-600">*</span>:
              </label>
              <select
                id="call_back_reason"
                name="call_back_reason"
                value={formData.call_back_reason}
                onChange={handleChange}
                className="p-2 border border-gray-300 rounded"
                required
              >
                <option value="">Select Reason</option>
                <option value="Call Back">Call Back</option>
                <option value="Counselling">Counselling</option>
                <option value="EOD">EOD</option>
              </select>
            </div>
          )}
          {formData.is_interested === "Others" && (
            <div className="mt-4 flex items-center">
              <label htmlFor="other_reasons" className="font-medium mr-4">
                Specify Other Reason
                <span className="ml-1 text-red-600">*</span>:
              </label>
              <select
                id="other_reasons"
                name="other_reasons"
                value={formData.other_reasons}
                onChange={handleChange}
                className="p-2 border border-gray-300 rounded"
                required
              >
                <option value="">Select Reason</option>
                <option value="Wrong Number">Wrong Number</option>
                <option value="Not Reachable">Not Reachable</option>
                <option value="Number Not Working">Number Not Working</option>
                <option value="Call Declined">Call Declined</option>
                <option value="Busy">Busy</option>
                <option value="Switched Off">Switched Off</option>
                <option value="Incoming Calls Stopped">
                  Incoming Calls Stopped
                </option>
              </select>
            </div>
          )}
        </div>

        <div className="flex flex-col col-span-1 sm:col-span-2">
          <label
            htmlFor="remarks"
            className="mb-1 font-medium flex items-center"
          >
            Remarks
          </label>
          <textarea
            id="remarks"
            name="remarks"
            value={formData.remarks}
            onChange={handleChange}
            className="p-2 bg-slate-100 border rounded"
            rows="3"
          ></textarea>
        </div>

        <div className="flex flex-col col-span-1 sm:col-span-2">
          <button
            type="submit"
            className={`w-full py-3 mt-4 text-lg font-semibold bg-blue-600 text-white rounded-md transition ${
              loadingSubmit
                ? "cursor-not-allowed bg-blue-400"
                : "hover:bg-blue-700"
            }`}
            disabled={loadingSubmit}
          >
            {loadingSubmit ? "Submitting..." : "Enroll Student"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EnrollStudent;